<template>
  <div>
    
    <div class="columns" v-if="!this.hideUpdate==true" >
      <div class="column">
        <b-field  label="Título">
          <b-input v-model="titleFilter"></b-input>
        </b-field>
      </div>
      
      <div class="column">
        <b-field label="Tipo de sección:">
          <multiselect v-model="bookopcion"
                       :options="bookopciones"
                       placeholder="Seleccione tipo"
                       selectLabel="Presione para seleccionar"
                       selectedLabel="Seleccionado"
                       >
            <template v-slot:noOptions>
              No existen datos
            </template>
            <span slot="noResult">
                        No se encontraron elementos.
                    </span>
          </multiselect>
        </b-field>
      </div>
    </div>
    <div class="columns" v-if="!this.hideUpdate==true">
      <div class="column">
        <b-field label="Año" >
          <multiselect v-model="year"
                       :options="years"
                       placeholder="Seleccione año"
                       selectLabel="Presione para seleccionar"
                       selectedLabel="Seleccionado"
                       deselectLabel="No se puede deseleccionar"
                       :allow-empty="false">
            <template v-slot:noOptions>
              No existen datos
            </template>
            <span slot="noResult">
                        No se encontraron elementos.
                    </span>
          </multiselect>
        </b-field>
      </div>


      
      <div class="column" v-if="!this.hideUpdate==true && (bookopcion=='Libro' || bookopcion==null)" >
        <b-field label="Editorial">
          <b-autocomplete v-model="editorial_name"
                          :keep-first="keepFirst"
                          :open-on-focus="openOnFocus"
                          :data="editoriales_filtradas"
                          field="name"
                          empty="Vacio"
                          @typing="getRevistasFiltradas"
                          @select="option => {if (option) {editorial_id = option.id} }"
                          :clearable="clearable">
                          <template slot-scope="props">
                            <div>
                              {{props.option.name}}
                            </div>
                          </template>
                          <template #empty>No se encontraron resultados</template>
                        </b-autocomplete>
        </b-field>
      </div>

    </div>
    <div class="columns has-text-right">
      <div class="column ">
          <b-field v-if="!this.hideUpdate==true" label="">
          <b-button type="is-info"
                    icon-left="search"
                    v-if="!this.hideUpdate==true"
                    @click="updateBooksFilter()">
            Buscar
          </b-button>
        </b-field>
      </div>
    </div>
    <div class="columns has-text-right">
      <div class="column">
        <b-switch v-model="cardLayout">Formato tarjeta (sin filtros ni búsqueda)
             <b-tooltip
                 label="Al presionar sobre algún nombre de cabecera de la tabla, se ordenarán los datos según este criterio"
                 multilined
                 position="is-left">
                  <b-icon
                      pack="fas"
                      icon="info-circle"
                      type="is-info">
                  </b-icon>
              </b-tooltip></b-switch>
      </div>
      
    </div>
      
    <b-table
        :data="libros"
        :paginated=true
        per-page=10
        striped
        hoverable
        :card-layout="cardLayout"
        :current-page="currentPage"
        :pagination-simple=false
        pagination-position="bottom"
        default-sort-direction="desc"
        sort-icon="arrow-up"
        sort-icon-size="is-small"
        default-sort="publication.publication_date"
        aria-next-label="Siguiente"
        aria-previous-label="Anterior"
        aria-page-label="Página"
        aria-current-label="Página actual"
        :opened-detailed="defaultOpenedDetails"
        detailed
        detail-key="title"
        @details-open="(row) => $buefy.toast.open(`Expanded ${row.title}`)"
        :show-detail-icon="showDetailIcon"
        >
      <b-table-column
          field= 'title'
          label= 'Título'
          width="30em"
          searchable
          sortable>
        <template
            slot="searchable"
            slot-scope="props">
          <b-input
              v-model="props.filters[props.column.field]"
              icon="search"
              size="is-small" />
        </template>
        <template v-slot="props">
          <a :href="getBookUrl(props.row.id)">{{ props.row.title}}</a>
        </template>
      </b-table-column>
      <b-table-column
          v-if="!this.hideUpdate==true"
          field= 'publication_type'
          label= 'Tipo de Sección'
          width="6em"
          searchable
          sortable>
        <template
            slot="searchable"
            slot-scope="props">
          <b-input
              v-model="props.filters[props.column.field]"
              icon="search"
              size="is-small" />
        </template>
        <template v-slot="props">
          <span v-if="props.row.publication_type=='Book'">Libro</span>
          <span v-if="props.row.publication_type=='Inbook'">Artículo de Libro </span>
          <span v-if="props.row.publication_type=='Booklet'" >Capítulo de Libro </span>
        </template>
      </b-table-column>
      

      <b-table-column
          field= 'editorial'
          label= 'Editorial'
          searchable
          sortable>
        <template
            slot="searchable"
            slot-scope="props">
          <b-input
              v-model="props.filters[props.column.field]"
              icon="search"
              size="is-small" />
        </template>
        <template v-slot="props">
          <span v-if="props.row.publication_type=='Book'">
            {{ props.row.editorial }}
          </span>
          <span v-else>
              
          </span>
        </template>
      </b-table-column>
      <b-table-column
          field= 'publication_date'
          label= 'Fecha de publicación'
          searchable
          :custom-search="searchPublicationDate"
          sortable>
        <template
            slot="searchable"
            slot-scope="props">
          <b-input
              v-model="props.filters[props.column.field]"
              icon="search"
              size="is-small" />
        </template>
        <template v-slot="props">
            {{ props.row.publication_date._isValid ? new Date(props.row.publication_date).toLocaleDateString("es-CL"): '' }}
        </template>
      </b-table-column>

      <b-table-column
          v-if="cargoPrincipal.name == 'ANALISTA I+D FING' || cargoPrincipal.name == 'SUPERADMIN'"
          label="Acciones"
          v-slot="props">
        <b-icon
            pack="fas"
            icon="trash"
            size="is-medium"
            type="is-danger"
            @click.native="execNullifyModal(props.row.id, props.row)"/>
      </b-table-column>

      <template slot="detail" slot-scope="props">
        <article class="media">
          <div class="media-content">
            <div class="content">
              <p>
                <strong>Autores: </strong>
                <span>{{props.row.participants_references}}</span>
              </p>
            </div>
          </div>
        </article>
      </template>

      <template slot="empty" slot-scope="props">
        <div class="columns is-centered">
          <div class="column is-6 is-centered has-text-centered">
            <b-message type="is-danger">
              No se encontraron resultados para el año seleccionado.
            </b-message>
          </div>
        </div>
      </template>


    </b-table>
    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>

  </div>
</template>
<script>
import {searchDate} from "../../packs/utilities";
import axios from "axios";
export default {
  props:[
      'libros','hideUpdate','cargoPrincipal'
  ],
  data(){
    return{
      isLoading:false,
      currentPage:1,
      cardLayout:false,
      defaultOpenedDetails: [1],
      showDetailIcon: true,
      year: new Date().getFullYear(),
      years:[],
      bookopciones: ["Libro", "Capítulo Libro", "Artículo Libro"],
      isNullifyActive: false,
      editorial_name: null,
      keepFirst: false,
      openOnFocus: false,
      editoriales_filtradas:[],
      editoriales: [],
      editorial_id: null,
      bookopcion: null,
      clearable: false,
      titleFilter: '',
    }
  },
  created(){
    this.years = this.generateArrayOfYears();
  },
  methods:{
    getBookUrl(book_id){
      return "/books/"+book_id;
    },
    generateArrayOfYears() {
      var max = new Date().getFullYear()
      var min = 1980
      var years = []
      years.push("Todo")
      for (var i = max; i >= min; i--) {
        years.push(i)
      }
      return years
    },
    updateBooks(){
      this.$emit('updateBooks',this.year)
    },
    updateBooksFilter(){
      var type_book = null
      if(this.bookopcion=="Libro")
        type_book = 2
      else if(this.bookopcion=="Capítulo Libro"){
        type_book = 3
        this.editorial_id = null
      }
      else if(this.bookopcion=="Artículo Libro"){
        this.editorial_id = null
        type_book = 5
      }

      var datos = {
        year: this.year,
        editorial: this.editorial_id,
        name: this.titleFilter,
        type: type_book
      }
      this.$emit('updateBooksFilter',datos)
    },
    async getRevistasFiltradas(text) {
      this.isLoading=true;
      await axios
        .get("/editorials/search.json", {
          params: {name: text,}
        })
        .then(res => {
          this.editoriales = res.data;
          this.editorial_id = null

            this.editoriales_filtradas = this.editoriales.filter((option) => {
              let returnOption = option.name
                  .toString()
                  .toLowerCase()
                  .indexOf(text.toLowerCase()) >= 0
              return returnOption;
            }).slice(0,30)


          setTimeout(()=>{
            this.isLoading = false
          },3000);
        }).
        catch(error => {
          this.isLoading=false;
          //console.log(error)
        })



    },
    searchPublicationDate(row,input){
      return searchDate(row.publication_date,input)
    },
    execNullifyModal(id, row){

      let titulo = ""
      let msj = ""
      let msjError = ""
      let msjExito = ""
      let conf = ""
      let tipo = 0

      if (row.publication_type=='Book'){
        titulo = "Anular Libro"
        msj = '¿Está seguro que desea <b>anular</b> el libro? Esta acción lo dejará inválido.<br>'
        msjError = '<b>Libro no pudo ser anulado</b><br>'
        msjExito = "Libro anulado correctamente"
      }
      else if (row.publication_type == 'Inbook'){
        titulo = "Anular Artículo de Libro"
        msj = '¿Está seguro que desea <b>anular</b> el artículo de libro? Esta acción lo dejará inválido.<br>'
        msjError = '<b>artículo de Libro no pudo ser anulado</b><br>'
        msjExito = "Artículo de libro anulado correctamente"
      }
      else if (row.publication_type == 'Booklet'){
        titulo = "Anular Capítulo de Libro"
        msj = '¿Está seguro que desea <b>anular</b> el capítulo de libro? Esta acción lo dejará inválido.<br>'
        msjError = '<b>Capítulo de Libro no pudo ser anulado</b><br>'
        msjExito = "Capítulo de libro anulado correctamente"
      }



      this.$buefy.dialog.confirm({
        title: titulo,
        message: msj,
        confirmText: titulo,
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.isNullifyActive = true
          this.isLoading = true
          axios
              .delete("/books/" + id + "/nullify_book.json")
              .then(res => {
                this.$buefy.dialog.alert({
                  message: msjExito,
                  duration: 5000,
                  type: 'is-success',
                  canCancel: ["escape", "outside"]
                })

                var index = this.libros.indexOf(row)
                this.libros.splice(index, 1)
                this.isLoading = false;
                this.isNullifyActive = false;
              }).catch(error => {
            console.log(error)
            this.$buefy.dialog.alert({
              message: msjError+error.response.data,
              duration: 5000,
              type: 'is-danger',
              canCancel: ["escape", "outside"]
            })
            this.isLoading = false;
            this.isNullifyActive = false;
          })
        }
      })
    },

  },
  watch:{
    isNullifyActive: function () {
      if (!this.isNullifyActive) {
        this.updateBooksFilter()
      }
    },
  },
  computed:{

  }
}
</script>